// WebWorkers.js

import WebWorker from "./WebWorker";

class WebWorkers {
	constructor() {
		this.workers = {};
	}

	add(workerName, workerModule, onSuccess, onError) {
		this.workers[workerName] = new WebWorker(
			workerName,
			workerModule,
			onSuccess,
			onError
		);
	}

	execute(workerName, args) {
		if (workerName in this.workers) this.workers[workerName].execute(args);
		else throw "WebWorker named: " + workerName + " is not exist!";
	}

	terminate(workerName) {
		if (workerName != null) {
			this.terminateWorker(workerName);
		} else {
			let workersName = Object.keys(this.workers);
			workersName.forEach(workerName => {
				this.terminateWorker(workerName);
			});
		}
	}

	terminateWorker(workerName) {
		this.workers[workerName].terminate();
		delete this.workers[workerName];
	}
}

export default new WebWorkers();
